import {AxiosInstance, AxiosResponse} from 'axios';
//api
import {orgAPI} from '@/core/api';
//types
import {IGetTeamResData, ITeamCreateMemberReqBody, ITeamReqData, ITeamUpdateData} from '@/utils/types';
//enum
import {API_URL, updateMemberRole} from '../enums/api-url.enum';
import {ITeamRole} from '../enums';

class OrganizationTeamService {
	static getTeam = async (reqBody: ITeamReqData, apiInstance: AxiosInstance): Promise<AxiosResponse<IGetTeamResData>> =>
		apiInstance.get(
			`${API_URL.TEAM}?organizationId=${reqBody.organizationId}&role=${reqBody.role}&activity=${reqBody.activity}&searchName=${reqBody.searchName}&page=${reqBody.page}&pageSize=${reqBody.pageSize}`
		);

	static createTeamMember = async (reqBody: ITeamCreateMemberReqBody): Promise<AxiosResponse> =>
		orgAPI.post(API_URL.CREATE_TEAM_MEMBER, reqBody);

	static updateTeamRole = async (id: number, role: ITeamRole): Promise<AxiosResponse> =>
		orgAPI.put(updateMemberRole(id, role));

	static deleteTeamMember = async (id: number): Promise<AxiosResponse> => orgAPI.delete(`${API_URL.TEAM}/${id}`);

	static generateTeamMemberPassword = async (): Promise<AxiosResponse> => orgAPI.get(API_URL.TEAM_GENERATE_PASSWORD);

	static presignedImage = async (): Promise<AxiosResponse> => orgAPI.get(API_URL.TEAM_PRESIGN_IMAGE);

	static resendInvite = async (id: number): Promise<AxiosResponse> =>
		orgAPI.post(`${API_URL.TEAM_RESEND_INVITE}?teamId=${id}`);

	static updateTeamMember = async (id: number, reqBody: ITeamUpdateData): Promise<AxiosResponse> =>
		orgAPI.put(`${API_URL.TEAM}/${id}/member`, reqBody);
}

export {OrganizationTeamService};
